import * as React from 'react'
import styled from 'styled-components/macro'
import TopImage from 'assets/images/Launcher/resized_launcher_header.jpg'
import launcher1 from 'assets/images/Launcher/launcher-1.jpg'
// import launcher2 from 'assets/images/Launcher/launcher-2.jpg'

// import Button from 'common/Button'
import InstagramRow from 'common/InstagramRow'
import LauncherQuoteModal from './LauncherQuoteModal'
import FAQ from 'common/FAQ'
import FAQQuestions from './FAQQuestions.json'
import Logo from 'assets/images/Launcher/Logo.svg'
import Button from 'common/Button'
import ContentSection from 'common/ContentSection'

const TopImageSection = styled.div`
  position: relative;
`

const StyledLogo = styled.img`
  max-width: 90vw;
`

const BannerImg = styled.img`
  height: auto;
  width: 100%;
  min-height: 490px;
  object-fit: cover;
`

const LogoAndButton = styled.div`
  position: absolute;
  top: 33%;
  left: 50%;
  transform: translate(-50%, 0%);
  display: flex;
  flex-direction: column;
  align-items: center;
`

// const LogoImg = styled.img`
//   width: 100%;
//   height: auto;
// `

// const StyledButton = styled(Button)`
//   background: var(--darker-grey);
//   :hover {
//     background-color: var(--light-green);
//   }
// `

const StyledButton = styled(Button)`
  font-family: 'Rubik';
  font-weight: 700;
  background-color: var(--darker-grey);
`

const Launcher = () => {
  const [showQuoteModal, setShowQuoteModal] = React.useState(false)
  return (
    <>
      <TopImageSection>
        <BannerImg src={TopImage}></BannerImg>
        <LogoAndButton>
          <StyledLogo src={Logo}></StyledLogo>{' '}
          <StyledButton
            onClick={() => setShowQuoteModal(true)}
            message={'Reserve Now'}
          ></StyledButton>
        </LogoAndButton>
      </TopImageSection>
      <ContentSection
        img={launcher1}
        imgAlt="Raise More Funds"
        alignImg="right"
        heading="Fan-favorite fundraising activity"
        content="Players can launch a golf ball upwards of 450 yards utilizing our state-of-the-art, no-kick golf ball launchers."
        background="dark"
        type="Launcher"
        localOnly={true}
        hideButtonMobile={true}
      />
      <ContentSection
        youtubeLink="https://www.youtube.com/embed/Cpg_Aldotnw"
        imgAlt="An unforgettable on-course experience"
        alignImg="left"
        heading="An unforgettable on-course experience"
        content="Participants are guaranteed to remember a golf outing utilizing The Launcher. Increase funds raised by offering a sponsorship opportunity for this conversation-starting experience."
        type="Launcher"
        localOnly={true}
        hideButtonMobile={true}
      />
      {/* <RaiseMoreFunds setShowQuoteModal={setShowQuoteModal} />
      <UnforgettableSection setShowQuoteModal={setShowQuoteModal} /> */}
      <InstagramRow />
      <script async src="//www.instagram.com/embed.js"></script>
      <FAQ setShowQuoteModal={setShowQuoteModal} FAQQuestions={FAQQuestions} />
      <LauncherQuoteModal
        setShowQuoteModal={setShowQuoteModal}
        showQuoteModal={showQuoteModal}
      />
    </>
  )
}
export default Launcher
